import { cn } from 'helpers/css';
import React from 'react';
import { Progress as ProgressReactstrap } from 'reactstrap';

const Progress = ({ value, animated, style, barStyle, className, children }) => {
  //! State

  //! Function

  //! Render
  return (
    <ProgressReactstrap
      animated={animated}
      style={style}
      barStyle={barStyle}
      className={cn(
        'tw-rounded-full [&_.progress-bar]:tw-bg-primary dark:[&_.progress-bar]:tw-text-black',
        className
      )}
      value={value}
    >
      {children}
    </ProgressReactstrap>
  );
};

export default Progress;
